/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isPromise(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
//# sourceMappingURL=isPromise.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isPromise.js
// module id = 898
// module chunks = 1